export default __webpack_public_path__ + "static/blob5-c25e348899e3e08519c5298c3d63dc8b.svg";